var client;
var google;

let scriptEle = document.createElement("script");
let route = `https://maps.googleapis.com/maps/api/js?key=${getKey()}&libraries=places&language=en&callback=getKey`;
scriptEle.setAttribute("src", route);

let stripeRouteEle = document.createElement("script");
route = 'https://js.stripe.com/v3/';
stripeRouteEle.setAttribute("src", route);

function getKey() {
    if (window.location.href.includes('.recuvery.com')) {
        return 'AIzaSyDuayE9g_ErYJHUDNwcELxOoaiidjG4E2k';
    } else {
        return 'AIzaSyAudUxsyfqNreXJdNllGSnMiyWZqdZHF-I'
    }
}
document.head.appendChild(scriptEle)
document.head.appendChild(stripeRouteEle);